import Loading from '@/shared/components/Carregando';
import { DataAmigavel } from '@/shared/utils/datas';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { Fragment, useEffect, useRef, useState } from 'react';
import { GetSubstituicoesPeriodos } from '@/modules/business/periodo/periodo.service';
import { ReadDefensorResponseDto, ReadLotacaoDto, ReadSubstituicaoDto } from '@/api.types';
import { LotacaoService } from '@/modules/business/lotacoes/lotacao.service';
import { SearchDtoLotacoes } from '@/shared/types/search.dto';
import { TipoLotacao } from '../enums/tipo-lotacao.enum';
import { TipoLotacaoList } from '@/shared/constants/enumlist';
import { toast } from 'react-toastify';

interface IMyProps {
  exibirAnotacoes: boolean;
  exibirTudo: boolean;
  agruparDefensoria: boolean;
}

export default function RelatorioDefensoresLotacoes({
  exibirAnotacoes,
  exibirTudo,
  agruparDefensoria,
}: IMyProps) {
  const lotacaoService = new LotacaoService();

  const [defensores, setDefensores] = useState<ReadDefensorResponseDto[]>();
  const [lotacoes, setLotacoes] = useState<ReadLotacaoDto[]>();
  const [substituicoes, setSubstituicoes] = useState<ReadSubstituicaoDto[]>();
  const [loading, setLoading] = useState<boolean>(true);

  const contentRef = useRef<HTMLTableElement>(null);

  useEffect(() => {
    Promise.all([
      EnumerateDefensores(0, 1000, true, true),
      lotacaoService.Enumerate({
        skip: 0,
        take: 9000,
        somente_ativas: !exibirTudo,
        vigente: !exibirTudo,
      } as SearchDtoLotacoes),
      GetSubstituicoesPeriodos(-1, exibirTudo),
    ])
      .then((results) => {
        setDefensores(results[0].objects);
        setLotacoes(results[1][0]);
        setSubstituicoes(
          results[2].objects.sort((a, b) => {
            const dataInicialA = a.periodo?.data_inicial ?? '';
            const dataInicialB = b.periodo?.data_inicial ?? '';
            return dataInicialA < dataInicialB ? 1 : -1;
          }),
        );
        setLoading(false);
      })
      .catch((error) => {
        toast.error('Erro ao montar relatório.');
        console.warn('ERRO:', error);
      });
  }, [loading, exibirTudo]);

  function ExibirData(lotacao: ReadLotacaoDto) {
    let texto = lotacao.data_inicial || lotacao.data_final ? ' (' : '';

    if (lotacao.data_inicial)
      texto += `desde ${DataAmigavel(lotacao.data_inicial)}`;

    if (lotacao.data_final) texto += ` até ${DataAmigavel(lotacao.data_final)}`;

    texto += lotacao.data_inicial || lotacao.data_final ? ')' : '';

    return <span className="text-muted small">{texto}</span>;
  }

  function ExibirDataEmSubstituicoes(substituicao: ReadSubstituicaoDto) {
    if (!substituicoes) return null;

    const { periodo, defensoria, substituto } = substituicao;
    const diversosRegistros = agruparDefensoria
      ? substituicoes.filter(
        (item) =>
          item.defensoria?.id === defensoria?.id &&
          item.substituto?.id === substituto?.id &&
          item !== substituicao,
      )
      : [];

    if (diversosRegistros.length > 0)
      return (
        <span className="text-muted small">
          {' '}
          (diversos períodos em {diversosRegistros.length + 1} registros)
        </span>
      );

    const dataInicial = periodo?.data_inicial
      ? `desde ${DataAmigavel(periodo.data_inicial)}`
      : '';
    const dataFinal = periodo?.data_final
      ? ` até ${DataAmigavel(periodo.data_final)}`
      : '';
    const texto =
      dataInicial || dataFinal ? ` (${dataInicial}${dataFinal})` : '';

    return <span className="text-muted small">{texto}</span>;
  }

  function TipoLotacaoExtenso(tipo: TipoLotacao) {
    const nomeLotacao = TipoLotacaoList.find((a) => a.value === tipo)?.name;
    return <span title={nomeLotacao}>[{nomeLotacao?.substring(0, 1)}] </span>;
  }

  if (loading) return <Loading />;

  return (
    <div>
      <h4 className="text-center relatorio-font relatorio-titulo">
        Tabela simplificada de lotações dos defensores.
      </h4>
      <br />

      <table
        className="table table-sm table-bordered table-striped align-middle"
        ref={contentRef}
      >
        <thead>
          <tr>
            <th>Nome</th>
            <th>Atuações Vigentes</th>
          </tr>
        </thead>
        <tbody>
          {defensores &&
            defensores
              .filter((defensor) => {
                const temLotacao = lotacoes?.some((a) => a.defensor?.id === defensor.id);
                const temSubstituicao = substituicoes?.some(
                  (a) => a.substituto?.id === defensor.id,
                );
                return Boolean(temLotacao || temSubstituicao);
              })
              .map((defensor, index) => {
              return (
                <Fragment key={index}>
                  <tr>
                    <td>{defensor.pessoa?.nome}</td>
                    <td>
                      {lotacoes &&
                        lotacoes
                          .filter((a) => a.defensor?.id == defensor.id)
                          .map((lotacao, index2) => {
                            return (
                              <Fragment key={index2}>
                                <span>
                                  <span
                                    className={
                                      lotacao.ativo ? '' : `text-muted`
                                    }
                                  >
                                    {TipoLotacaoExtenso(lotacao.tipo)}
                                    {lotacao.defensoria?.nome}
                                    {lotacao.nucleo?.nome}
                                  </span>
                                </span>
                                {ExibirData(lotacao)}
                                {exibirAnotacoes && (
                                  <>
                                    <span className="text-muted small float-end">
                                      {lotacao.anotacao1} {lotacao.anotacao2}
                                    </span>
                                  </>
                                )}
                                <br />
                              </Fragment>
                            );
                          })}
                      {substituicoes &&
                        substituicoes
                          .filter((a) => a.substituto?.id == defensor.id)
                          .filter((value, index, array) => {
                            if (agruparDefensoria)
                              return (
                                index ===
                                array.findIndex(
                                  (item) =>
                                    item.defensoria?.id === value.defensoria?.id,
                                )
                              );
                            return true;
                          })

                          .map((substituicao, index3) => {
                            return (
                              <Fragment key={index3}>
                                <span
                                  className="text-muted"
                                  title="Substituição"
                                >
                                  [S]
                                </span>{' '}
                                <span>{substituicao.defensoria?.nome}</span>
                                <span>
                                  {ExibirDataEmSubstituicoes(substituicao)}
                                </span>
                                <br />
                              </Fragment>
                            );
                          })}
                    </td>
                  </tr>
                </Fragment>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
